<script>
import numeral from 'numeral'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import utilStyles from '@/assets/scss/modules/utilities.module.scss'
import { toThaiDatetime } from '@/utils/datetime'

export default {
  functional: true,

  props: {
    items: {
      type: Array,
      default: () => []
    },

    pagination: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  render(h, { data, props, listeners }) {
    const DetailButton = ({ props }) => {
      const handleClick = () => {
        listeners.view && listeners.view(props.dataId)
      }

      return (
        <el-button size="medium" onClick={handleClick}>
          See Detail <i class="el-icon-arrow-right"></i>
        </el-button>
      )
    }

    return (
      <el-card
        {...{ ...data, on: undefined }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
        {...{ directives: [{ name: 'loading', value: props.loading }] }}
      >
        <el-table
          data={props.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
        >
          <el-table-column
            label="วันที่"
            minWidth="150"
            scopedSlots={{ default: ({ row }) => toThaiDatetime(row.date) }}
          />
          <el-table-column
            label="เลขตั๋วขายฝาก"
            prop="ticketNo"
            minWidth="150"
          />
          <el-table-column label="กิจกรรม" prop="type" minWidth="100" />
          <el-table-column
            label="เพิ่ม"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) =>
                row.amount > 0 ? (
                  <span
                    class={utilStyles.colorSuccess}
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            label="ลด"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) =>
                row.amount < 0 ? (
                  <span
                    class={utilStyles.colorDanger}
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            label="คงเหลือ (กรัม)"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) => (
                <span style={{ fontWeight: 'bold' }}>
                  {numeral(row.left).format('0,0.00')}
                </span>
              )
            }}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => <DetailButton dataId={row.refId} />
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={props.pagination.page}
            total={props.pagination.total}
            pageSize={props.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'current-change': value => {
                listeners.pageChange && listeners.pageChange(value)
              }
            }}
          />
        </div>
      </el-card>
    )
  }
}
</script>
